/* global axios */
import ApiClient from './ApiClient';

class TasksAPI extends ApiClient {
  constructor() {
    super('tasks', { accountScoped: true });
  }

  list(params = {}) {
    return axios.get(this.url, { params });
  }

  get(id) {
    return axios.get(`${this.url}/${id}`);
  }

  create(payload) {
    return axios.post(this.url, payload);
  }

  update(id, payload) {
    return axios.patch(`${this.url}/${id}`, payload);
  }

  remove(id) {
    return axios.delete(`${this.url}/${id}`);
  }

  complete(id) {
    return axios.post(`${this.url}/${id}/complete`);
  }

  reopen(id) {
    return axios.post(`${this.url}/${id}/reopen`);
  }

  notifications() {
    return axios.get(`${this.url}/notifications`);
  }
}

export default new TasksAPI();
